import _ from 'lodash';
import moment from 'moment';
import parseItemNo from './utils/parseItemNo';

function findPrice(item, timestamp) {
  if (!item.RetailItemCommPriceList || !item.RetailItemCommPriceList.RetailItemCommPrice) {
    return null;
  }
  // support IOWS RetailItemComm price format
  if (item.RetailItemCommPriceList.RetailItemCommPrice.Price) {
    
    return item.RetailItemCommPriceList.RetailItemCommPrice;
  }
  return item.RetailItemCommPriceList.RetailItemCommPrice.find((p) => timestamp.isBetween(p.ValidFromDateTime || '2001-01-01', p.ValidToDateTime || '2099-12-31'));
}

function findDualPrice(item, timestamp) {
  if (!item.RetailItemCommPriceList || !item.RetailItemCommPriceList.RetailItemCommPrice) {
    return null;
  }

  if(item.RetailItemCommPriceList.RetailItemCommPrice.length > 1){
    if(item.ItemType === 'SGR'){
      console.log("findDualPrice - item.RetailItemCommPriceList.RetailItemCommPrice is: ", item);
    }
    return item.RetailItemCommPriceList.RetailItemCommPrice[1];
  }
  return false;
}

function findFamilyPrice(item, timestamp) {
  if (!item.RetailItemCommFamilyPriceList || !item.RetailItemCommFamilyPriceList.RetailItemCommFamilyPrice) {
    return null;
  }
  // support IOWS RetailItemComm price format
  if (item.RetailItemCommFamilyPriceList.RetailItemCommFamilyPrice.FamilyPrice) {
    return item.RetailItemCommFamilyPriceList.RetailItemCommFamilyPrice;
  } 
  return item.RetailItemCommFamilyPriceList.RetailItemCommFamilyPrice.find((p) => p.FamilyPrice && timestamp.isBetween(p.ValidFromDateTime || '2001-01-01', p.ValidToDateTime || '2099-12-31'));
}

function findDualFamilyPrice(item, timestamp) {
  if (!item.RetailItemCommFamilyPriceList || !item.RetailItemCommFamilyPriceList.RetailItemCommFamilyPrice) {
    return null;
  }
  // support IOWS RetailItemComm price format
  if (item.RetailItemCommFamilyPriceList.RetailItemCommFamilyPrice.FamilyPrice) {
    if(item.RetailItemCommFamilyPriceList.RetailItemCommFamilyPrice.FamilyPrice.length > 1){
      return item.RetailItemCommFamilyPriceList.RetailItemCommFamilyPrice[1];
    }
  } 
  return false;
}

export function generateItems(items, businessRules) {
  const { ignoreItems } = businessRules;
  const now = moment();
  const result = items
  .filter((item) => item)
  .map((item) => {
    const p = findPrice(item, now);
    const dp = findDualPrice(item, now);
    const fp = findFamilyPrice(item, now);
    const dfp = findDualFamilyPrice(item, now);

    return {
      ...item,
      ItemNo: parseItemNo(item.ItemNo),
      price: p && p.Price,
      priceExclTax: p && p.PriceExclTax,
      dualPrice: dp && dp.Price,
      dualPriceExclTax: dp && dp.PriceExclTax,
      familyPrice: fp && fp.FamilyPrice,
      familyPriceExclTax: fp && fp.FamilyPriceExclTax,
      dualFamilyPrice: dfp && dfp.FamilyPrice,
      dualFamilyPriceExclTax: dfp && dfp.FamilyPriceExclTax,
    };
  })
  .filter(({ ItemNo, price }) => {
    if (typeof price === 'undefined' || price === null) {
      console.warn('Excluding', ItemNo, 'due to no valid price available');
      return false;
    }
    else if(ignoreItems && ignoreItems.length > 0 && ignoreItems.find((itemNo)=> itemNo == ItemNo))
    {
      console.warn('Excluding item ', ItemNo, ' due to manual filtering');
      return false;
    }
    return true;
  });

  const articles = _.groupBy(result.filter(({ ItemType }) => ItemType === 'ART'), (item) => item.ItemNo);
  return _.reduce(result, (output, item) => {
    if (item.ItemType === 'SPR' && item.RetailItemCommChildList) {
       /* eslint-disable no-param-reassign */
      const [defined, missing] = _.partition(item.RetailItemCommChildList.RetailItemCommChild, (child) => articles[child.ItemNo]);

      if (missing.length > 0) {
        const itemNos = missing.map((child) => `ART-${child.ItemNo}`).join(', ');
        // eslint-disable-next-line no-console
        console.error(`Excluding SPR-${item.ItemNo} due to missing child(s) ${itemNos}`);
      } else {
        item.articles = defined.map((child) => ({
          amount: child.Quantity,
          item: articles[child.ItemNo][0],
        }));
      }

      if (!item.articles) {
        return output;
      }
    }

    output.push(item);
    return output;
  }, []);
}
